var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c("div", { staticClass: "input--imgRadio input--imgRadio--container" }, [
        _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t(_vm.literal))),
        ]),
        _c(
          "ul",
          { staticClass: "input__wrapper grid" },
          _vm._l(_vm.options, function (option) {
            return _c(
              "li",
              { class: { "is-selected": option.key === _vm.value } },
              [
                _c(
                  "label",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(option.key)
                      },
                    },
                  },
                  [
                    _c("input", {
                      attrs: { type: "radio", name: _vm.name },
                      domProps: {
                        value: option.key,
                        checked: _vm.isChecked(option.key),
                      },
                    }),
                    _vm.elementHasImage(option)
                      ? _c("div", {
                          staticClass: "input__img",
                          class: { "roof-angle": _vm.isRoofAngle },
                          style: _vm.inlineStyle(option),
                        })
                      : _c(
                          "div",
                          { staticClass: "emptyDamage" },
                          [
                            _c("svgicon", {
                              staticClass: "icon",
                              attrs: {
                                name: "empty-damage",
                                height: "24",
                                width: "24",
                                color: "#7CAACF",
                              },
                            }),
                          ],
                          1
                        ),
                    _c(
                      "p",
                      {
                        staticClass: "text-medium black",
                        class: { "roof-angle-literal": _vm.isRoofAngle },
                      },
                      [_vm._v(_vm._s(_vm.getLiteral(option)))]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }